var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMainLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32.41 31.42",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#fff;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M16.21,14a1.72,1.72,0,1,0,1.72,1.72A1.72,1.72,0,0,0,16.21,14Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M16.21,11.11a1.24,1.24,0,1,0,1.23,1.23A1.24,1.24,0,0,0,16.21,11.11Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M16.21,17.85a1.23,1.23,0,1,0,1.23,1.23A1.24,1.24,0,0,0,16.21,17.85Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M12.84,17a1.24,1.24,0,1,0-1.23-1.24A1.24,1.24,0,0,0,12.84,17Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 19.58,
    cy: 15.71,
    r: 1.23
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "14.94 14.26 14.08 11.96 11.66 11.11 12.53 13.41 14.94 14.26"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "17.47 14.26 19.88 13.41 20.75 11.11 18.34 11.96 17.47 14.26"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "17.47 17.14 18.34 19.44 20.75 20.29 19.88 17.98 17.47 17.14"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "14.94 17.14 12.53 17.98 11.66 20.29 14.08 19.44 14.94 17.14"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M14.12,26.52a7.88,7.88,0,0,0,2.21,4.9,8.27,8.27,0,0,0,2-4.9,8.28,8.28,0,0,0-2-4.91A7.89,7.89,0,0,0,14.12,26.52Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M15.37,21.12s-3.34,0-4.62,2.05S10,26.47,9.43,28.1a3.87,3.87,0,0,1-2.57,2.12s2.58,2.49,4.73-.18c.83-1,1.31-2.77,1.55-5.41A4.24,4.24,0,0,1,15.37,21.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M23,28.1c-.56-1.63,0-2.85-1.32-4.93s-4.62-2.05-4.62-2.05a4.21,4.21,0,0,1,2.22,3.51C19.51,27.27,20,29,20.82,30c2.15,2.67,4.74.18,4.74.18A3.85,3.85,0,0,1,23,28.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M14.12,4.91A7.92,7.92,0,0,1,16.33,0a8.31,8.31,0,0,1,2,4.91,8.31,8.31,0,0,1-2,4.91A7.92,7.92,0,0,1,14.12,4.91Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M15.37,10.3s-3.34,0-4.62-2S10,5,9.43,3.32A3.87,3.87,0,0,0,6.86,1.2s2.58-2.49,4.73.19c.83,1,1.31,2.77,1.55,5.41A4.21,4.21,0,0,0,15.37,10.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M23,3.32C22.43,5,23,6.17,21.67,8.26s-4.62,2-4.62,2a4.19,4.19,0,0,0,2.22-3.5c.24-2.64.72-4.38,1.55-5.41C23-1.29,25.56,1.2,25.56,1.2A3.85,3.85,0,0,0,23,3.32Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M9.82,15.83a7.92,7.92,0,0,0-4.91-2.21A7.92,7.92,0,0,0,0,15.83a8.31,8.31,0,0,0,4.91,2A8.31,8.31,0,0,0,9.82,15.83ZM4.91,14.55A6.09,6.09,0,0,1,8.3,15.79a6.67,6.67,0,0,1-3.39,1.09,6.74,6.74,0,0,1-3.4-1.09A6.16,6.16,0,0,1,4.91,14.55Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M8.53,10.25C6.44,9,5.23,9.49,3.6,8.93A3.81,3.81,0,0,1,1.48,6.36S-1,8.94,1.66,11.1c1,.83,2.77,1.31,5.41,1.55a4.21,4.21,0,0,1,3.51,2.22S10.61,11.54,8.53,10.25Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M10.58,16.55a4.24,4.24,0,0,1-3.51,2.23c-2.64.24-4.38.72-5.41,1.55-2.67,2.15-.18,4.73-.18,4.73A3.83,3.83,0,0,1,3.6,22.49c1.63-.55,2.84,0,4.93-1.32S10.58,16.55,10.58,16.55Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M22.6,15.83a7.89,7.89,0,0,1,4.91-2.21,7.88,7.88,0,0,1,4.9,2.21,8.27,8.27,0,0,1-4.9,2A8.28,8.28,0,0,1,22.6,15.83Zm4.91-1.28a6.13,6.13,0,0,0-3.4,1.24,6.74,6.74,0,0,0,3.4,1.09,6.67,6.67,0,0,0,3.39-1.09A6.12,6.12,0,0,0,27.51,14.55Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M23.89,10.25C26,9,27.19,9.49,28.82,8.93a3.85,3.85,0,0,0,2.12-2.57s2.49,2.58-.19,4.74c-1,.83-2.77,1.31-5.41,1.55a4.21,4.21,0,0,0-3.5,2.22S21.8,11.54,23.89,10.25Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M21.84,16.55a4.23,4.23,0,0,0,3.5,2.23c2.64.24,4.38.72,5.41,1.55,2.68,2.15.19,4.73.19,4.73a3.87,3.87,0,0,0-2.12-2.57c-1.63-.55-2.85,0-4.93-1.32S21.84,16.55,21.84,16.55Z"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMainLogo);
export default __webpack_public_path__ + "static/media/mainLogo.d4be5f217547e86b413b29916d842b99.svg";
export { ForwardRef as ReactComponent };